import { useMemo } from 'react';
import { Snackbar } from '@material-ui/core';
import { ReactHtmlParser } from 'shared_ui_components';
import { imageBasePath } from 'constants';
import classes from './SnackBar.module.scss';

const TimeSnackbar = ({ open, message, type, onClose = () => null }) => {
  const iconImg = useMemo(() => {
    if (!type) return '';
    return imageBasePath + type + '.svg';
  }, [type]);

  return (
    <div className={classes.snackbarContent}>
      <Snackbar open={open} autoHideDuration={3000} onClose={onClose} className={'snackbar'}>
        <div className={type}>
          <p className={type + ' paragraph'}>
            <img alt="" className="toastIcon" src={iconImg} />
            <ReactHtmlParser content={message} />
          </p>
        </div>
      </Snackbar>
    </div>
  );
};

export default TimeSnackbar;
